import useAuth from "../../hooks/authenticate/useAuth";
import useConfig from "../../hooks/useConfig";
import YsbBarChartWeekly from "./YsbContainer/YsbBarChartWeekly";
// import YsbCombinedComponents from "./YsbContainer/YsbCombinedComponents";
import NationalParkCombinedComponents from "./NationalParkContainer/NationalParkCombinedComponents";
import YsbHourlyBarChartComponent from "./YsbContainer/YsbHourlyBarChartComponent";
// import ChartsToday from "./EilatContainer/ChartsToday";
// import EilatGouge from "./EilatContainer/EilatGouge";
// import EilatGougeAndChartToday from "./EilatContainer/EilatGougeAndChartToday";
// import EilatReports from "./EilatContainer/EilatReports";
const NationalParkContainer = () => {
  const { config } = useConfig();
  const { auth } = useAuth();
  // previous classname className="w-full flex flex-col items-center p-4 shadow-xl  backdrop-blur-xl  bg-blue-900 bg-opacity-30  rounded-xl "
  return (
    <div className="w-full flex flex-col items-center p-4 rounded-xl ">
      <section className="w-full h-full">
        <NationalParkCombinedComponents token={auth.token} areas={config.areas} />
        {/* <YsbCombinedComponents  /> */}
      </section>
        {/* <YsbBarChartWeekly token={auth.token} /> */}
      {/* <div className=" w-full h-full mt-2 flex flex-col shadow-md rounded-xl bg-white   ">
        <YsbHourlyBarChartComponent token={auth.token} areas={config.areas} />
      </div> */}
    </div>
  );
};
export default NationalParkContainer;
